<template>
  <button type="button" class="btn-next" :disabled="internalDisabled" :aria-label="nextText || t('z.pagination.next')"
    :aria-disabled="internalDisabled" @click="$emit('click', $event)">
    <span v-if="nextText">{{ nextText }}</span>
    <z-icon v-else>
      <component :is="nextIcon" />
    </z-icon>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useLocale } from '@zoryn/hooks'
import { ZIcon } from '@zoryn/components/icon'
import { paginationNextProps } from './next'

defineOptions({
  name: 'ZPaginationNext',
})

const props = defineProps(paginationNextProps)

defineEmits(['click'])

const { t } = useLocale()

const internalDisabled = computed(
  () =>
    props.disabled ||
    props.currentPage === props.pageCount ||
    props.pageCount === 0
)
</script>
